import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import './eltabs.scss';

const ElTabs = ({ onChange, titles, children }) => {
  const [selected, changeSelection] = useState(0);
  const selectionChange = item => {
    if (onChange) {
      onChange(item);
    }
    changeSelection(item);
  };
  return (
    <div className='tabsContainer'>
      <section className='titles'>
        {titles.map((title, index) => (
          <div
            key={String(title)}
            onClick={() => selectionChange(index)}
            className={index === selected ? 'title current' : 'title'}
          >
            {title}
          </div>
        ))}
      </section>
      <div className='content'>{children[selected]}</div>
    </div>
  );
};

ElTabs.propTypes = {
  titles: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  onChange: PropTypes.func
};

export default ElTabs;
